import { FieldValues } from 'react-hook-form';
import { useFormSectionContext } from '@/components/Form/FormSectionContext';
import { View } from 'react-native';
import { PropsWithChildren } from 'react';

type FormSectionHeaderProps = PropsWithChildren<{
  displayForSection: number[];
}>;

const FormSectionHeader = <T extends FieldValues>(props: FormSectionHeaderProps) => {
  const { displayForSection, children } = props;
  const { currentSection, sectionsCount } = useFormSectionContext<T>();

  if (sectionsCount === undefined || !displayForSection.includes(currentSection)) {
    return null;
  }
  return (
    <View
      style={{
        flexDirection: 'row',
        paddingBottom: 25,
      }}
    >
      {children}
    </View>
  );
};

export default FormSectionHeader;
